export type Tool = { name: string; route: string };

export const materialCollectors: Tool[] = [
  { name: "FoilCutter1", route: "/foil-cutter-1" },
  { name: "FoilCutter2", route: "/foil-cutter-2" },
  { name: "Cell", route: "/cell" },
  { name: "Silicon", route: "/silicon" },
  { name: "Pre-Lami El-Cell Yield", route: "/prelami" },
  { name: "Cross Connection", route: "/cross-connection" },
  { name: "Glass Loader 1", route: "/glass-loader-1" },
  { name: "Glass Loader 2", route: "/glass-loader-2" },
  { name: "Potting", route: "/potting" },
  { name: "El-Images", route: "/el-images" },
  { name: "Stringer", route: "/stringer" },
];

export const qualityProcesses: Tool[] = [
  { name: "String Peel", route: "/string-peel" },
  { name: "Foil Peel", route: "/foil-peel" },
];
